import React, { useState } from 'react'

import format from 'date-fns/format'

import { Table } from 'components/table'
import { useNameToDomainMappings } from 'hooks/useNameToDomainMappings'

import NameToDomainFilters from './NameToDomainFilters'

const config = [
  {
    title: 'Alias',
    field: 'alias',
  },
  {
    title: 'Name',
    field: 'name',
  },
  {
    title: 'Domain',
    field: 'domain',
  },
  {
    title: 'Date',
    render: ({ checked_at }: any) => format(checked_at, 'dd-MM-yyyy HH:mm:ss'),
  },
]

const NameToDomainSearch = () => {
  const [search, setSearch] = useState('')
  const { data, isLoading, error, fetchNextPage, hasNextPage } = useNameToDomainMappings(search)

  const mappings = data?.pages.flatMap((page: any) => page.mappings || []) ?? []

  return (
    <Table
      config={config}
      data={mappings}
      error={error ? 'Error occurred when loading mappings' : undefined}
      loading={isLoading}
      onLoadMore={hasNextPage ? () => fetchNextPage() : undefined}
      title="Mappings"
      toolbar={<NameToDomainFilters onSearch={setSearch} />}
    />
  )
}

export default NameToDomainSearch
